import request from '@/utils/request'


// 查询宠物每日睡眠统计列表
export function listSleepDaily(query) {
  return request({
    url: '/mibo/pet-sleep-daily/list',
    method: 'get',
    params: query
  })
}

// 查询宠物每日睡眠统计分页
export function pageSleepDaily(query) {
  return request({
    url: '/mibo/pet-sleep-daily/page',
    method: 'get',
    params: query
  })
}

// 查询宠物每日睡眠统计详细
export function getSleepDaily(data) {
  return request({
    url: '/mibo/pet-sleep-daily/detail',
    method: 'get',
    params: data
  })
}

// 新增宠物每日睡眠统计
export function addSleepDaily(data) {
  return request({
    url: '/mibo/pet-sleep-daily/add',
    method: 'post',
    data: data
  })
}

// 修改宠物每日睡眠统计
export function updateSleepDaily(data) {
  return request({
    url: '/mibo/pet-sleep-daily/edit',
    method: 'post',
    data: data
  })
}

// 删除宠物每日睡眠统计
export function delSleepDaily(data) {
  return request({
    url: '/mibo/pet-sleep-daily/delete',
    method: 'post',
    data: data
  })
}
